import { render, staticRenderFns } from "./PhilosophyComponent.vue?vue&type=template&id=65f1454a&"
import script from "./PhilosophyComponent.vue?vue&type=script&lang=js&"
export * from "./PhilosophyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports